import paths from "../../api/paths.api";
import { ALL_PLANT_MODULE_NAMES, APP_MODULES } from "../../constants/appModules";

export const userNavItems = [
  // Estimation and EPCM used to be separate destinations (paths.myEstimation
  // and paths.myProjects); both are superseded by the sidebar tree
  // (AppSidebar), which already surfaces a project's Estimation entry points
  // per-plant (see the nine-dot launcher's Estimation group). "Project" just
  // opens the tree with an empty page until something's picked there - see
  // ProjectLanding. Gated the same way "EPCM" was, since that's what the
  // tree itself requires to show anything (see AppSidebar's
  // `showProjectsTree`).
  {
    label: "Project",
    type: "link",
    link: paths.myProjects,
    modulesAny: ALL_PLANT_MODULE_NAMES,
  },
  {
    label: "AIMS",
    type: "link",
    link: paths.ams,
    module: APP_MODULES.AIMS,
  },
  // {
  //   label: "Project Data",
  //   type: "link",
  //   link: paths.emsExplorer,
  //   module: APP_MODULES.EMS,
  // },
  {
    label: "Software",
    type: "link",
    link: paths.softwares,
    module: APP_MODULES.SOFTWARE,
  },
  {
    label: "Client data",
    type: "link",
    link: paths.clientVendors,
  },
  {
    label: "Licences",
    type: "link",
    link: paths.licenceManagement,
    adminOnly: true,
    module: APP_MODULES.LICENCE_ADMIN,
  },
];
